import { Http, Headers } from "@angular/http";
import { map } from 'rxjs/operators';
import { GLOBAL } from './global';
var FilemakerService = /** @class */ (function () {
    function FilemakerService(_http) {
        this._http = _http;
        this.url = GLOBAL.url;
    }
    FilemakerService.prototype.guardarExpediente = function (draft) {
        console.log(draft);
        var headers = new Headers({
            'Content-type': 'application/json',
            'Authorization': sessionStorage.getItem("token-domCloud")
        });
        return this._http.post(this.url + 'save/exp', draft, { headers: headers })
            .pipe(map(function (res) { return res.json(); }));
    };
    return FilemakerService;
}());
export { FilemakerService };
